import script from "./AdminConsumerDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminConsumerDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminConsumerDashboardView.vue?vue&type=style&index=0&id=09f3aca8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f3aca8"]])

export default __exports__